import { MapDataConnectionsStepContent } from "components/ChartOfAccounts/ImportCOA/MapDataConnectionsStep";
import Modal from "components/DesignSystem/Modal/Modal";
import { IMPORT_SOURCE } from "constants/qboImportSteps";
import { useImportFinally } from "./ImportFinallyContext";
import { ImportFinallyHeader } from "./ImportFinallyHeader";

type FinallyMapDataConnectionsStepProps = {
  importProcessId: string;
};

export const FinallyMapDataConnectionsStep = ({
  importProcessId,
}: FinallyMapDataConnectionsStepProps) => {
  const {
    entityId,
    onNext,
    bankMapFormValues,
    setBankMapFormValues,
    isOpen,
    close,
  } = useImportFinally();

  const handleOpenChange = () => close({ takeConfirmation: true });

  return (
    <Modal.Root open={isOpen} onOpenChange={handleOpenChange} modal={false}>
      <Modal.Content size="xl" useCustomOverlay>
        <MapDataConnectionsStepContent
          onNext={onNext}
          importProcessId={importProcessId}
          entityId={entityId}
          header={<ImportFinallyHeader />}
          initialValues={bankMapFormValues || undefined}
          onFormValuesChange={setBankMapFormValues}
          source={IMPORT_SOURCE.FINALLY}
          shouldHideNoneOption
        />
      </Modal.Content>
    </Modal.Root>
  );
};
